var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-input", {
        attrs: {
          label: _vm.field.name,
          clearable: true,
          "required-mark": _vm.field.required,
          placeholder: "+7 (___) ___ ____",
          mask: "+7 (###) ### ####",
          required: _vm.error,
          "required-message": _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }